import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Subscription } from 'api/billing/types';
import { Button } from 'components/atoms/button';
import { PlanSelection } from './plan-selection';

const TrialExtensionNote = styled.div`
  color: #f86068;
  font-size: var(--heading-6-size);
  text-align: right;
  opacity: 0.7;
  margin-top: var(--spacing-06);

  Button {
    color: inherit;
    font-size: inherit;
    padding: 0 !important;
    text-decoration: underline;
    &:hover {
      color: inherit;
    }
  }
`;

export const TrialSubscriptionSettings = ({
  subscription,
}: {
  subscription: Subscription;
}) => {
  const openChat = useCallback(() => {
    window.fcWidget?.open();
  }, []);

  return (
    <>
      <PlanSelection subscription={subscription} />
      <TrialExtensionNote>
        <FormattedMessage
          id="billing.trial.extension.text"
          values={{
            link: (chunks) => (
              <Button type="link" onClick={openChat}>
                {chunks}
              </Button>
            ),
          }}
        />
      </TrialExtensionNote>
    </>
  );
};
